export const loadGlobalStatusBannerBar = (): Promise<typeof import("./global-status-banner-bar")> =>
  import("./global-status-banner-bar");
